import { gql, TypedDocumentNode } from '@common/hooks';
import { HistoryInfoFragment } from '@common/graphql';
import {
  MobileNotificationPreferencesQueryCgResponse,
  MobileNotificationPreferencesQueryVariables,
  WorkerDetailQueryCgResponse,
  WorkerDetailQueryVariables,
  WorkerIsInternalQueryCgResponse,
  WorkerIsInternalQueryVariables,
  WorksIntegrationConfigurationQueryCgResponse,
  WorksIntegrationConfigurationQueryVariables,
} from '@common/graphql/schema';

export type ShiftGapType = {
  id: string;
  timeZone: string;
  startDatetime: string;
  role: RoleType;
  organizationUnit: {
    id: string;
    name: string;
    costCenter: string;
  };
};

export type WorksShiftType = {
  id: string;
  startDatetime: string;
  perHourIncentivePay: number;
  status: string;
  showUnitName: boolean;
  lastStateChangeDatetime?: number;
  duration?: number;
  shiftGap: ShiftGapType;
  createdAt: string;
};

export type OrganizationUnitType = {
  id: string;
  name: string;
  costCenter?: string;
  department: {
    id: string;
    organizationBusiness: {
      id: string;
      name: string;
    };
  };
};

export type RoleType = {
  id: string;
  abbreviation: string;
};

export type AllowListItemType = {
  id: string;
  organizationUnit: {
    id: string;
  };
  role: RoleType;
};

export const WorkerDetailQuery: TypedDocumentNode<
  WorkerDetailQueryCgResponse,
  WorkerDetailQueryVariables
> = gql`
  query WorkerDetail($id: ID!) {
    worker(id: $id) {
      id
      isInternal
      employeeId
      active
      baseRate
      worksUser {
        id
        firstName
        lastName
        name
        email
        phone
      }
      allowedUnits {
        id
        name
        costCenter
        department {
          id
          organizationBusiness {
            id
            name
          }
        }
      }
      allowLists {
        id
        organizationUnit {
          id
        }
        role {
          id
          abbreviation
        }
      }
      role {
        id
        abbreviation
      }
      homeUnit {
        id
        name
        costCenter
        department {
          id
          organizationBusiness {
            id
            name
          }
        }
      }
      workforceGroup {
        id
        name
        active
      }
      history {
        ...HistoryInfoFragment
      }
    }
  }
  ${HistoryInfoFragment}
`;

export const MobileNotificationPreferences: TypedDocumentNode<
  MobileNotificationPreferencesQueryCgResponse,
  MobileNotificationPreferencesQueryVariables
> = gql`
  query MobileNotificationPreferences($workerId: ID!) {
    mobileNotificationPreferences(workerId: $workerId) {
      notificationName
      pushEnabled
      smsEnabled
      label
      description
    }
  }
`;

export const WorksIntegrationConfigurationQuery: TypedDocumentNode<
  WorksIntegrationConfigurationQueryCgResponse,
  WorksIntegrationConfigurationQueryVariables
> = gql`
  query WorksIntegrationConfiguration($workerId: String) {
    integrationConfiguration(workerId: $workerId) {
      workerIntegrationEnabled
      allowListSyncEnabled
      editingAllowListsPermitted
      workerFound
      integrationType
      mappedHomeUnit
    }
  }
`;

export const WorkerIsInternalQuery: TypedDocumentNode<
  WorkerIsInternalQueryCgResponse,
  WorkerIsInternalQueryVariables
> = gql`
  query WorkerIsInternal($id: ID!) {
    worker(id: $id) {
      id
      isInternal
    }
  }
`;
